module.exports = __webpack_public_path__ + "images/116_1024.jpg";